module.exports = require('react-dom/lib/ReactPerf');


//////////////////
// WEBPACK FOOTER
// ./~/react-addons-perf/index.js
// module id = 423
// module chunks = 0